import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from 'utility/icomoon';
import DropdownInput from '../DropdownInput';

const ThemeDropdown = (props) => {
  const { useLabel = true, placeholder, forceinitialvalue, required = false } = props;
  const intl = useIntl();

  //TEMAS
  const [themes, setThemes] = useState(
    [...Array(36).keys()]
      .filter((id) => id !== 5)
      .map((id) => ({
        id: id,
        value: id,
        label: <FormattedMessage id={`units.theme${id}`} />,
        label_intl: intl.formatMessage({ id: `units.theme${id}` }),
        icon: <Icon icon={intl.formatMessage({ id: `units.theme${id}.icon` })} />
      }))
  );

  //Reset value with initial when values are loaded from db
  const [resetValue, setResetValue] = useState(Date.now());
  const resetDropdown = () => {
    setResetValue(Date.now());
  };

  useEffect(() => {
    let fixedThemes = themes;
    fixedThemes.push({
      id: 200,
      value: 200,
      label: <FormattedMessage id={`units.theme200`} />,
      label_intl: intl.formatMessage({ id: `units.theme200` }),
      icon: <Icon icon={intl.formatMessage({ id: `units.theme200.icon` })} size={15} />
    });
    setThemes(fixedThemes);
  }, []);

  return (
    <>
      <DropdownInput
        {...props}
        key={resetValue}
        label={useLabel ? props.label || <FormattedMessage id="units.theme" /> : null}
        options={props.options || themes}
        placeholder={
          placeholder ??
          useIntl().formatMessage({
            id: 'common.all'
          })
        }
        forceinitialvalue={forceinitialvalue ?? null}
        required={required}
      />
    </>
  );
};

ThemeDropdown.defaultProps = {};

export default ThemeDropdown;
